import UserLayout from "../components/UserLayout";
import Contact from "../components/Contact";
const ContactPage = () => {
    return (
        <UserLayout>
            <Contact />
        </UserLayout>
    );
}

export default ContactPage;